/**
 * @file dnd-ru.ts
 * @description Объявления перетаскивания для программ чтения экрана по-русски
 * (phase19.16 Р2; dnd-kit `accessibility`): по умолчанию dnd-kit говорит
 * по-английски («Picked up draggable item…»). Общие для структуры страницы,
 * сетки секции и списков в панелях элементов.
 */

import type { Announcements, ScreenReaderInstructions } from "@dnd-kit/core";

/** Подсказка, как перетаскивать с клавиатуры. */
export const DND_INSTRUCTIONS_RU: ScreenReaderInstructions = {
  draggable:
    "Чтобы перенести, нажмите пробел или Enter. Стрелками выберите новое место, ещё раз пробел или Enter — поставить, Escape — отменить.",
};

/** Объявления: что взяли, над чем держим, куда поставили. */
export const DND_ANNOUNCEMENTS_RU: Announcements = {
  onDragStart: () => "Элемент взят. Стрелками выберите новое место.",
  onDragOver: ({ over }) => (over ? "Элемент над новым местом." : "Элемент вне списка."),
  onDragEnd: ({ over }) => (over ? "Элемент поставлен на новое место." : "Элемент возвращён на прежнее место."),
  onDragCancel: () => "Перенос отменён, элемент на прежнем месте.",
};

/** Свойство `accessibility` для `DndContext`. */
export const DND_ACCESSIBILITY_RU = { announcements: DND_ANNOUNCEMENTS_RU, screenReaderInstructions: DND_INSTRUCTIONS_RU };
